import React from "react";
import { ArrowRight, Globe, Server, Zap } from "lucide-react";
import "../hero.css";

const Hero = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section id="hero" className="hero">
      <div className="hero-container">
        <div className="hero-content">
          <div className="hero-badge">
            <Zap size={16} />
            Professional Web Solutions
          </div>

          <h1 className="hero-title">
            Build Your Digital Presence with
            <span className="brand-accent">OIGHosting</span>
          </h1>

          <p className="hero-description">
            From stunning website creation to reliable hosting solutions, we
            provide everything your business needs to succeed online.
            Professional quality, affordable prices.
          </p>

          <div className="hero-buttons">
            <button
              onClick={() => scrollToSection("website-packages")}
              className="hero-primary-button"
            >
              View Website Packages
              <ArrowRight size={20} />
            </button>
            <button
              onClick={() => scrollToSection("hosting-plans")}
              className="hero-secondary-button"
            >
              Explore Hosting Plans
            </button>
          </div>

          <div className="hero-features">
            <div className="hero-feature-card">
              <div className="hero-feature-icon">
                <Globe size={32} />
              </div>
              <h3 className="hero-feature-title">Custom Websites</h3>
              <p className="hero-feature-description">
                Professionally designed websites tailored to your business needs
              </p>
            </div>

            <div className="hero-feature-card">
              <div className="hero-feature-icon">
                <Server size={32} />
              </div>
              <h3 className="hero-feature-title">Reliable Hosting</h3>
              <p className="hero-feature-description">
                Fast, secure, and reliable hosting solutions with 99.9% uptime
              </p>
            </div>

            <div className="hero-feature-card">
              <div className="hero-feature-icon">
                <Zap size={32} />
              </div>
              <h3 className="hero-feature-title">24/7 Support</h3>
              <p className="hero-feature-description">
                Expert support whenever you need it, keeping your site running
                smoothly
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Background decoration */}
      <div className="hero-bg-decoration"></div>
    </section>
  );
};

export default Hero;
